import { Flex, Pagination } from '@applyboard/crystal-ui';
import { useSearchResult } from '../context/SearchResultContext';
import { queryParameterContext } from '../context';
import { useStaticProps } from '../context/StaticPropsContext';

export function ProgramsPagination() {
  const pageNumberFilter = queryParameterContext.useFilterField('pageNumber', 'Pagination');
  const pageSizeFilter = queryParameterContext.useFilterField('pageSize', 'Pagination');

  const { totalPrograms } = useSearchResult();
  const { referenceData } = useStaticProps();

  return (
    <Flex align="center" pt={10} grow={1}>
      <Flex.Item grow={1}>
        <Pagination
          numItems={totalPrograms}
          currentPage={pageNumberFilter.value}
          pageSize={pageSizeFilter.value}
          onPageSizeChange={(pageSize) => pageSizeFilter.setValue(pageSize)}
          disabled={totalPrograms <= 0}
          onPageChange={(pageNumber) => pageNumberFilter.setValue(pageNumber)}
          variant="items"
          pageSizeOptions={referenceData.pageSizes}
        />
      </Flex.Item>
    </Flex>
  );
}
